














import { Component, Prop, Vue } from 'vue-property-decorator'
import { CreateProjectFormModel } from '@/views/Projects/Create.vue'

@Component
export default class CreateProjectForm extends Vue {
    @Prop() readonly value!: CreateProjectFormModel
}
